// Setup › WORKSPACE › Model policy (MODEL-POLICY): `/c/{slug}/setup/model-policy`. Core feature,
// managers (the Setup gate).
import { createRoute } from "@tanstack/react-router";
import { ModelPolicyScreen } from "../features/model-policy/model-policy";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupModelPolicyRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "model-policy",
  component: function SetupModelPolicyPage() {
    const { api } = setupModelPolicyRoute.useRouteContext();
    return <ModelPolicyScreen api={api} company={useCompany()} />;
  },
});
